export default __webpack_public_path__ + "static/media/wrinkles.a87f8512.svg";